(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["solawi-bid-frontend"] = factory();
	else
		root["solawi-bid-frontend"] = factory();
})(globalThis, () => {
return 